module.exports = __webpack_public_path__ + "img/G_lineG_def@2x.a4ebd2b6.png";